import { render, staticRenderFns } from "./UserContactInfo.vue?vue&type=template&id=00da3ce6"
import script from "./UserContactInfo.vue?vue&type=script&lang=js"
export * from "./UserContactInfo.vue?vue&type=script&lang=js"
import style0 from "./UserContactInfo.vue?vue&type=style&index=0&id=00da3ce6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.28_css-loader@6.11.0_webpack@5.105.2__lodash@4_64be4d9407eb667fe9a1e2476327747d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports